/**
 * Small modal shown when the user clicks "+" to add a page.
 * Offers two paths: a blank page (today's default) or a page from
 * another template (kicks off the template-selector add-page flow).
 */

import { createModal } from './components.js';
import { escapeHTML as escHtml } from '../shared/html-escape.js';

export function showAddPageChooserModal({ onBlank, onFromTemplate }) {
  if (document.querySelector('.pb-add-page-chooser-overlay')) return;

  const choices = [
    {
      action: 'blank',
      label: 'Blank Page',
      description: 'Start with an empty page you can build up section by section.'
    },
    {
      action: 'from-template',
      label: 'From a Template',
      description: 'Copy a page from another template. Your nav and footer stay the same.'
    }
  ];

  const { body, footer, close } = createModal({
    title: 'Add a Page',
    className: 'pb-modal-add-page-chooser',
    overlayClassName: 'pb-add-page-chooser-overlay'
  });

  body.innerHTML = `
    <div class="pb-add-page-choices" role="group">
      ${choices
        .map(
          (c) => `
        <button type="button" class="pb-add-page-choice" data-action="${escHtml(c.action)}">
          <span class="pb-add-page-choice-label">${escHtml(c.label)}</span>
          <span class="pb-add-page-choice-desc">${escHtml(c.description)}</span>
        </button>
      `
        )
        .join('')}
    </div>
  `;
  footer.innerHTML = `<button class="pb-btn pb-btn-ghost" data-action="cancel">Cancel</button>`;

  footer.querySelector('[data-action="cancel"]').addEventListener('click', close);

  body.querySelector('[data-action="blank"]').addEventListener('click', () => {
    close();
    onBlank();
  });
  body.querySelector('[data-action="from-template"]').addEventListener('click', () => {
    close();
    queueMicrotask(() => onFromTemplate());
  });
}
